<ng-container *transloco="let t">
  <app-nav-tabs [reduceHorizontalSpacing]=true #nav>
    <app-nav-tab [title]="t('race.details.competitors')" [itemId]="1">
      <ng-template>
        <app-race-competitors-list-component [competitors]="competitors" [raceSettings]="race?.raceSettings"
                                             [applicationFormSettings]="race?.applicationFormSettings" [countries]="countries"
                                             [race]="race" [eventItem]="eventItem" [genders]="genders"
                                             [raceCommercialItems]="raceCommercialItems"
                                             [raceAdditionalItems]="raceAdditionalItems"
                                             (printStartList)="downloadStartList()"
                                             (refreshCounters)="onRefreshCounters()"
                                             [languages]="languages"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('race.details.results')" [itemId]="2">
      <ng-template>
        <app-race-results-list-component [results]="results" [race]="race" [eventItem]="eventItem" [genders]="genders"
                                         [languages]="languages" [categories]="categories"/>
      </ng-template>
    </app-nav-tab>
  </app-nav-tabs>
  <app-action-buttons-row [saveVisible]="false"/>
</ng-container>
